/**
 * Görünen asistan adı kuralı (F4; karar notu `docs/tasarim/asistan-adi-karari.md`). Kullanıcıya görünen her yüzeyde asistanın
 * adı, işi yapan AJAN PROFİLİNİN `display_name` değeridir; ad yoksa (boş/silinmiş profil) "Asistan". Teknik altyapı adı (bağlantı
 * türü, çalıştırıcı) hiçbir zaman ad olarak gösterilmez. Birden çok profil varsa her eylem kendi profilinin adıyla görünür; ortak
 * bir "kuruluş asistanı" adı türetilmez.
 */
import { z } from 'zod';
export const ASSISTANT_FALLBACK_NAME = 'Asistan';
export function assistantDisplayName(name) {
    const n = typeof name === 'string' ? name.trim() : '';
    return n === '' ? ASSISTANT_FALLBACK_NAME : n;
}
/**
 * Asistan eyleminin kimliği (denetim/etkinlik satırı): profil kimliği ve profilin GÜNCEL görünen adı (bulunamazsa `null` →
 * arayüz "Asistan" yazar). İnsan eylemlerinde `null`.
 */
export const assistantActorSchema = z
    .object({ profileId: z.guid(), name: z.string().nullable() })
    .nullable();
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/**
 * Denetim kaydının `data` alanından asistan profil kimliği: yalnız `actor: 'agent'` ve geçerli `agentProfileId` taşıyan, kullanıcısız
 * satırlar. İnsanın ajanla ilgili eylemi (ör. konuşmayı ajana devretmek; `actor: 'user'`) asistan eylemi DEĞİLDİR.
 */
export function assistantProfileIdOf(actorUserId, data) {
    if (actorUserId !== null || typeof data !== 'object' || data === null)
        return null;
    const d = data;
    const id = d['agentProfileId'];
    return d['actor'] === 'agent' && typeof id === 'string' && UUID.test(id)
        ? id.toLowerCase()
        : null;
}
//# sourceMappingURL=assistant-name.js.map